<script lang="ts">
  import { ACCORDION_ITEM_VARIANT } from '$lib/constants/constants';
  import { getAccordionOptions } from './context';
  import Plus from '../../../../assets/svgs/plus.svelte';
  import Minus from '../../../../assets/svgs/minus.svelte';

  // by default the accordion item is closed
  export let open = false;
  export let customClass: string | undefined = '';
  export let variant: string = 'default';

  // assign a unique identifier for the component
  const componentId = crypto.randomUUID();

  // get the accordion options using the context api
  const { collapse, activeComponentId } = getAccordionOptions();

  function setActive() {
    if ($activeComponentId === componentId) {
      $activeComponentId = null;
    } else {
      $activeComponentId = componentId;
    }
  }

  function toggleOpen() {
    open = !open;
  }

  function handleClick() {
    // if `collapse` is passed only one item can be active
    collapse ? setActive() : toggleOpen();
  }

  // the accordion item to be open by default
  $: open && collapse && setActive();
  // compare if the active id matches the component id
  $: isActive = $activeComponentId === componentId;
  // if `collapse`, set one item as active, otherwise use `open`
  $: isOpen = collapse ? isActive : open;
  $: navPadding = variant === ACCORDION_ITEM_VARIANT.NAV ? 'px-4 py-3' : '';
</script>

<div class="bg-gray-50 w-full rounded-xl {customClass}">
  <button
    on:click={handleClick}
    class="w-full flex justify-between cursor-pointer bg-none {navPadding} "
    aria-expanded={isOpen}
    aria-controls="accordion-{componentId}"
    style="-webkit-tap-highlight-color: transparent;"
  >
    <div>
      <slot name="title" />
    </div>
    {#if isOpen}
      <Minus />
    {:else}
      <Plus />
    {/if}
  </button>

  {#if isOpen}
    <div
      class="bg-gray-50 {variant === ACCORDION_ITEM_VARIANT.NAV ? 'px-8' : ''}"
      role="region"
      aria-hidden={!isOpen}
      aria-labelledby="accordion-{componentId}"
    >
      <slot name="content" />
    </div>
  {/if}
</div>
